import React from 'react';
import ReactDOM, { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { browserDiagnostic } from '@/utils/browserDiagnostic';
import { initializeAuthSession } from '@/utils/authSession';

// DEBUG: Import cache invalidation utility for development
// Debug import removed for production

console.log('main.tsx: Starting application initialization...');

// ИСПРАВЛЕНИЕ: Убираем дублирующую инициализацию authSession
// AuthContext уже управляет сессией через onAuthStateChange
console.log('🔐 [MAIN] Auth session will be managed by AuthContext...');

// КРИТИЧЕСКАЯ ДИАГНОСТИКА: Browser-specific проблемы с Supabase
console.log('🔍 [MAIN] Browser diagnostic starting...');
const diagnostic = browserDiagnostic.getFullDiagnostic();
console.log('🔍 [MAIN] Browser diagnostic completed:', diagnostic);

try {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error('Root element not found');
  }
  
  console.log('main.tsx: Root element found, creating React root...');
  const root = createRoot(rootElement);
  
  console.log('main.tsx: Rendering App component...');
  // ИСПРАВЛЕНО: Отключаем React.StrictMode для устранения двойных вызовов useEffect
  // которые вызывают race conditions и зависание getSession/onAuthStateChange
  root.render(
    <App />
  );
  
  console.log('main.tsx: App component rendered successfully');
} catch (error) {
  console.error('main.tsx: Failed to initialize application:', error);
  
  // Fallback: show error message
  const rootElement = document.getElementById("root");
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center; font-family: Arial, sans-serif;">
        <h1>Ошибка загрузки приложения</h1>
        <p>Произошла ошибка при инициализации приложения.</p>
        <p>Пожалуйста, обновите страницу или обратитесь в службу поддержки.</p>
        <details>
          <summary>Техническая информация</summary>
          <pre>${error}</pre>
        </details>
      </div>
    `;
  }
}
